import axios from "axios";

const api = axios.create({
  baseURL: "https://apibeta.vkover.com/",
  headers: {
    "Content-Type": "application/json",
  },
});
api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("session_token");

  if (token) {
    config.headers["X-Session-Token"] = token;
  }

  return config;
});
// api.interceptors.request.use((req) => {
//   const urlQueryStrings = new URLSearchParams(window.location.search);
//   const QuoteId = urlQueryStrings.get("quote_id");
//   if (QuoteId) {
//     req.headers.common["Quote-Id"] = QuoteId;
//   }
//   return req;// });
export default api;
